/** Normalize a workspace hostname or URL to its HTTPS origin. */
export function databricksWorkspaceOrigin(host: string): string {
  const value = host.trim();
  if (!value) throw new Error("databricks: workspace host cannot be empty.");
  const url = new URL(value.includes("://") ? value : `https://${value}`);
  if (url.username || url.password)
    throw new Error("databricks: workspace host must not contain credentials.");
  return url.origin;
}
